import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import $ from 'jquery'
import FlipCard from '../../../../Scripts/react-flipcard/lib/main';
import Front from './front';
import FrontInsights from './frontInsights';
import Back from './back';
import "../../../../Content/Less/flipCard.less";

class ProjectCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFlipped: false
		}
	}

	componentDidMount = () => {
		$('#' + this.props.projectId + 'bodyback').css("display", "none");
	};

	getProjectStatus = () => {
		if (!this.props.summary) {
			return 0
		}
		if (this.props.difference <= -7) {
			// Color the headder of the card in orange(warning color)
			return 1;
		}
		if (this.props.overAllocation < 0) {
			// Color the headder of the card in red(warning danger)
			return 2;
		}
	};

	showBack = () => {
		setTimeout(() => {
			$('#' + this.props.projectId + 'bodyback').css("display", "block");
		}, 200)
		setTimeout(() => {
			$('#' + this.props.projectId + 'bodyfront').css("display", "none");
		}, 200)
		this.setState({
			isFlipped: true
		});
	};
	showFront = () => {
		setTimeout(() => {
			$('#' + this.props.projectId + 'bodyback').css("display", "none");
		}, 200)
		setTimeout(() => {
			$('#' + this.props.projectId + 'bodyfront').css("display", "block");
		}, 200)
		this.setState({
			isFlipped: false
		});
	};

	render() {
		const {
			editContact, createContact, name, number, client, location,
			contacts, updateFavorite, favorite, projectId, summary, role, overAllocation, lastUpdate } = this.props;
		return (
			<div style={[styles.body, role==="Insights" && styles.insightsBody]}>
				<FlipCard
					disabled={true}
					flipped={this.state.isFlipped}
				>
					<div>
						{role==="Insights" ?
							<FrontInsights
								projectName={name}
								projectNumber={number}
								favorite={favorite}
								showBack={this.showBack}
								updateFavorite={updateFavorite}
								projectId={projectId}
								insights={summary}
								overAllocation={overAllocation}
								lastUpdate={lastUpdate}
								projectStatus={this.getProjectStatus()}
							/>
							:
							<Front
								projectName={name}
								projectNumber={number}
								client={client}
								favorite={favorite}
								location={location}
								showBack={this.showBack}
								updateFavorite={updateFavorite}
								projectId={projectId}
							/>
						}
					</div>
					<div>
						<Back
							projectName={name}
							contacts={contacts}
							showFront={this.showFront}
							editContact={editContact}
							createContact={createContact}
							projectId={projectId}
							role={role}
							projectStatus={this.getProjectStatus()}
						/>
					</div>
				</FlipCard>
			</div>
		);
	}
}

var styles = {
	body: {
		marginBottom: '30px',
		height: '605px',
		borderRadius: '2px'
	},
	insightsBody: {
		height: '310px'
	}
}
ProjectCard.propTypes = {
	editContact: PropTypes.func.isRequired,
	createContact: PropTypes.func.isRequired,
	updateFavorite: PropTypes.func.isRequired
};

export default Radium(ProjectCard);


// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/ProjectCard/index.jsx